/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";

const STATES = {
  POLLING: "polling",
  PAID: "paid",
  EXPIRED: "expired",
  ERROR: "error",
};

export default function RecModeConfirmation() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState(STATES.POLLING);
  const [data, setData] = useState(null);
  const [errMsg, setErrMsg] = useState("");
  const tries = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState(STATES.ERROR); setErrMsg("Missing session_id."); return; }

    const poll = async () => {
      if (tries.current >= 8) {
        setState(STATES.ERROR);
        setErrMsg("Payment status check timed out. Check your email for confirmation.");
        return;
      }
      tries.current += 1;
      try {
        const r = await api.get(`/spaces/recmode/checkout/status/${sessionId}`);
        setData(r.data);
        if (r.data.payment_status === "paid") { setState(STATES.PAID); return; }
        if (r.data.status === "expired") { setState(STATES.EXPIRED); return; }
        setTimeout(poll, 2000);
      } catch (e) {
        setErrMsg(e?.response?.data?.detail || "Could not verify payment.");
        setState(STATES.ERROR);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="rec-page">
      <header className="rec-topbar">
        <a href="/spaces/recmode" className="rec-brand"><span className="rec-brand-mark"><img src="/brand/metier-logo-gold.png" alt="Métier" /></span></a>
      </header>
      <main className="rec-main rec-confirm">
        {state === STATES.POLLING && (
          <div className="rec-confirm-card" data-testid="confirm-polling">
            <span className="m-eyebrow">Confirming</span>
            <h1 className="rec-h1">Verifying your <em>reservation…</em></h1>
            <p className="rec-desc">Hang tight, finalising payment with Stripe.</p>
          </div>
        )}
        {state === STATES.PAID && data?.booking && (
          <div className="rec-confirm-card" data-testid="confirm-success">
            <span className="m-eyebrow">Confirmed</span>
            <h1 className="rec-h1">You&apos;re <em>booked</em>.</h1>
            <p className="rec-desc">A confirmation has been emailed to {data.booking.email}. Stripe will issue a receipt automatically.</p>
            <div className="rec-confirm-grid">
              <div><span className="m-eyebrow small">Confirmation</span><span className="rec-conf-num" data-testid="confirm-number">#{data.booking.confirmation_number}</span></div>
              <div><span className="m-eyebrow small">Workspace</span><span>{data.booking.workspace_name}</span></div>
              <div><span className="m-eyebrow small">Date · Start</span><span>{data.booking.date} · {data.booking.start_time}</span></div>
              <div><span className="m-eyebrow small">Duration</span><span>{data.booking.hours} hours · {data.booking.unit}</span></div>
              <div><span className="m-eyebrow small">Total paid</span><span>${data.booking.amount.toFixed(2)} {data.booking.currency.toUpperCase()}</span></div>
            </div>
            <div className="rec-confirm-actions">
              <Link to="/spaces/recmode" className="m-btn-ghost">Book another time</Link>
              <a href="https://workmetier.com" className="m-btn-gold">Return to Métier</a>
            </div>
          </div>
        )}
        {state === STATES.EXPIRED && (
          <div className="rec-confirm-card" data-testid="confirm-expired">
            <span className="m-eyebrow">Session expired</span>
            <h1 className="rec-h1">Let&apos;s try <em>again</em>.</h1>
            <p className="rec-desc">Your checkout session expired before payment completed. No charge was made.</p>
            <Link to="/spaces/recmode" className="m-btn-gold">Return to listing</Link>
          </div>
        )}
        {state === STATES.ERROR && (
          <div className="rec-confirm-card" data-testid="confirm-error">
            <span className="m-eyebrow">Something went wrong</span>
            <h1 className="rec-h1">We hit a <em>snag</em>.</h1>
            <p className="rec-desc">{errMsg}</p>
            <Link to="/spaces/recmode" className="m-btn-gold">Try again</Link>
          </div>
        )}
      </main>
    </div>
  );
}
